(function () {
  const forms = document.querySelectorAll('.media-subscription__form');

  if (!forms.length) {
    return;
  }

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const honeypot = form.querySelector('.media-subscription__hp-input');

      if (honeypot && honeypot.value.trim() !== '') {
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const url = form.getAttribute('action');
      const emailInput = form.querySelector('[name="email"]');
      const consentInput = form.querySelector('[name="consent"]');
      const submitButton = form.querySelector('.media-subscription__submit');
      const widget = form.closest('.media-subscription');
      const successMessage = widget ? widget.querySelector('.media-subscription__message--success') : null;

      if (!emailInput || !url) {
        return;
      }

      if (!consentInput || !consentInput.checked) {
        if (widget) {
          widget.classList.remove('is-success', 'is-error-request');
          widget.classList.add('is-error-consent');
        }

        if (consentInput) {
          consentInput.focus();
        }

        return;
      }

      if (widget) {
        widget.classList.remove('is-error-consent', 'is-error-request');
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: emailInput.value.trim(),
          cf_hp: honeypot ? honeypot.value : '',
          consent: true,
        }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Subscription request failed');
          }

          return response.json();
        })
        .then(function () {
          if (widget) {
            widget.classList.remove('is-error-consent', 'is-error-request');
            widget.classList.add('is-success');
          }

          if (successMessage) {
            successMessage.focus();
          }
        })
        .catch(function (error) {
          console.error('Media subscription error:', error);

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }

          if (widget) {
            widget.classList.remove('is-error-consent');
            widget.classList.add('is-error-request');
          }

          if (emailInput) {
            emailInput.focus();
          }
        });
    });
  });
})();
